import httpInst from '../utilis/httpService';

const apiTestService = {

	getApiPayload: async (endpoint) => {
		const http = httpInst();
		const res = await http({
			method: 'get',
			url: `/${endpoint}`,
		});
	
		return res.data;
	},

}

export default apiTestService;